<template>
  <div>
    <!-- PESTAÑAS -->
    <div class="card">
      <div class="card-body h-100 p-0">
        <div class="d-flex align-items-start">
          <div class="flex-grow-1">
            <!-- INICIO -->
            <ul class="nav nav-tabs nav-fill w-100">
              <li class="nav-item">
                <a class="nav-link active" id="planAduccion" data-bs-toggle="tab" href="#ssplanAduccion" role="tab"
                  aria-controls="planAduccion" aria-selected="true"><i class="fa-solid fa-water"></i> Plan de
                  aduccion</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="volumenEmbalsado" data-bs-toggle="tab" href="#ssvolEmbalsado" role="tab"
                  aria-controls="volumenEmbalsado" aria-selected="true"><i
                    class="fa-solid fa-arrow-up-from-water-pump"></i> Volumen
                  embalsado</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="volTrasvases" data-bs-toggle="tab" href="#ssvolTrasvases" role="tab"
                  aria-controls="volTrasvases" aria-selected="true"><i class="fa-solid fa-bridge-water"></i>
                  Trasvases</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="volCaudalEcologico" data-bs-toggle="tab" href="#ssvolCaudalEcologico" role="tab"
                  aria-controls="volCaudalEcologico" aria-selected="true"><i class="fa-solid fa-seedling"></i> Caudal
                  Ecológico</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="volAportaciones" data-bs-toggle="tab" href="#ssvolAportaciones" role="tab"
                  aria-controls="volAportaciones" aria-selected="true"><i class="fa-solid fa-cloud-showers-water"></i>
                  Aportaciones</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="volReajustes" data-bs-toggle="tab" href="#ssvolReajustes" role="tab"
                  aria-controls="volReajustes" aria-selected="true"><i class="fa-solid fa-gear"></i> Reajustes</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="volEvaporaciones" data-bs-toggle="tab" href="#ssvolEvaporaciones" role="tab"
                  aria-controls="volEvaporaciones" aria-selected="true"><i class="fa-solid fa-smog"></i>
                  Evaporaciones</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- PESTAÑAS -->

    <!-- TABS -->
    <div class="row mt-3 ms-1 me-1">
      <div class="tab-content p-0" id="myTabContent">
        <!-- TAB Plan Aduccion -->
        <div class="tab-pane fade show active" id="ssplanAduccion" role="tabpanel" aria-labelledby="ssplanAduccion-tab">
          <AreaChart ref="planAduccionChart" class="card p-2" chartID="chartplanAduccion"
            :chartTitle="caudalesChartTitle" :dataSet="v_dataSet" selDataSet="planAduccion" yAxisUnit="m3/s" />
          <DataTable ref="planAduccionTable" globalID="planAduccionTable"
            :dataSet="v_dataSet && v_dataSet.planAduccion ? v_dataSet.planAduccion : {}"
            :isEditable="viewMode ? false : true" @updateValues="updateAduccion"
            :planFromDataBase="dataSetFromDatabase ? true : false" :interruptor="interruptor" />
        </div>

        <!-- TAB Volumen embalsado -->
        <div class="tab-pane fade show" id="ssvolEmbalsado" role="tabpanel" aria-labelledby="ssvolEmbalsado-tab">
          <AreaChart ref="volEmbalsadoChart" class="card p-2" chartID="chartplanVolumen"
            :chartTitle="volumenesChartTitle" selDataSet="planVolumen" :dataSet="v_dataSet" yAxisUnit="hm3" />
          <DataTable ref="volEmbalsadoTable" globalID="volEmbalsadoTable" :dataSet="v_dataSet && v_dataSet.planVolumen ? v_dataSet.planVolumen : {}
            " :isEditable="false" :interruptor="interruptor" />
        </div>

        <!-- TAB Volumen Reajustes -->
        <div class="tab-pane fade show" id="ssvolReajustes" role="tabpanel" aria-labelledby="ssvolReajustes-tab">
          <!-- Graficas reactivas -->
          <div class="row mt-3">
            <div class="col-12 col-md me-md-1 mb-3">
              <AreaChart ref="planAduccionChart2" :dataSet="v_dataSet" chartID="chartplanAduccion2"
                selDataSet="planAduccion" yAxisUnit="m3/s" estilo="width: 100%; height: 250px;" :yAxisLabel="false"
                :basicMode="true" style="border: 1px solid #ccc; padding: 5px" />
            </div>
            <div class="col-12 col-md mt-3 mt-md-0 ms-md-1">
              <AreaChart ref="volEmbalsadoChart2" :dataSet="v_dataSet" chartID="chartplanVolumen2"
                selDataSet="planVolumen" yAxisUnit="hm3" estilo="width: 100%; height: 250px;" :yAxisLabel="false"
                :basicMode="true" style="border: 1px solid #ccc; padding: 5px" />
            </div>
          </div>
          <DataTable ref="volReajustesTable" globalID="volReajustesTable" :dataSet="v_dataSet && v_dataSet.planReajustes
            ? v_dataSet.planReajustes
            : {}
            " :isEditable="viewMode ? false : true" @updateValues="updateReajustes"
            :planFromDataBase="dataSetFromDatabase ? true : false" :interruptor="interruptor" />
        </div>


        <!-- TAB Volumen Aportaciones -->
        <div class="tab-pane fade show" id="ssvolAportaciones" role="tabpanel" aria-labelledby="ssvolAportaciones-tab">
          <!-- Graficas reactivas -->
          <div class="row mt-3">
            <div class="col-12 col-md me-md-1 mb-3">
              <AreaChart ref="planAduccionChart4" :dataSet="v_dataSet" chartID="chartplanAduccion4"
                selDataSet="planAduccion" yAxisUnit="m3/s" estilo="width: 100%; height: 250px;" :yAxisLabel="false"
                :basicMode="true" style="border: 1px solid #ccc; padding: 5px" />
            </div>
            <div class="col-12 col-md mt-3 mt-md-0 ms-md-1">
              <AreaChart ref="volEmbalsadoChart4" :dataSet="v_dataSet" chartID="chartplanVolumen4"
                selDataSet="planVolumen" yAxisUnit="hm3" estilo="width: 100%; height: 250px;" :yAxisLabel="false"
                :basicMode="true" style="border: 1px solid #ccc; padding: 5px" />
            </div>
          </div>
          <DataTable ref="volAportacionesTable" globalID="volAportacionesTable" :dataSet="v_dataSet && v_dataSet.planAportaciones
            ? v_dataSet.planAportaciones
            : {}
            " :isEditable="viewMode ? false : true" @updateValues="updateAportaciones"
            :planFromDataBase="dataSetFromDatabase ? true : false" :interruptor="interruptor" />
        </div>

        <!-- TAB Volumen Trasvases -->
        <div class="tab-pane fade show" id="ssvolTrasvases" role="tabpanel" aria-labelledby="ssvolTrasvases-tab">
          <!-- Graficas reactivas -->
          <div class="row mt-3">
            <div class="col-12 col-md me-md-1 mb-3">
              <AreaChart ref="planAduccionChart3" :dataSet="v_dataSet" chartID="chartplanAduccion3"
                selDataSet="planAduccion" yAxisUnit="m3/s" estilo="width: 100%; height: 250px;" :yAxisLabel="false"
                :basicMode="true" style="border: 1px solid #ccc; padding: 5px" />
            </div>
            <div class="col-12 col-md mt-3 mt-md-0 ms-md-1">
              <AreaChart ref="volEmbalsadoChart3" :dataSet="v_dataSet" chartID="chartplanVolumen3"
                selDataSet="planVolumen" yAxisUnit="hm3" estilo="width: 100%; height: 250px;" :yAxisLabel="false"
                :basicMode="true" style="border: 1px solid #ccc; padding: 5px" />
            </div>
          </div>
          <DataTable ref="volTrasvasesTable" globalID="volTrasvasesTable" :dataSet="v_dataSet && v_dataSet.planTrasvases
            ? v_dataSet.planTrasvases
            : {}
            " :isEditable="viewMode ? false : true" @updateValues="updateTrasvases"
            :planFromDataBase="dataSetFromDatabase ? true : false" :interruptor="interruptor" />
        </div>

        <!-- TAB Volumen Caudal Ecológico -->
        <div class="tab-pane fade show" id="ssvolCaudalEcologico" role="tabpanel"
          aria-labelledby="ssvolCaudalEcologico-tab">
          <!-- Graficas reactivas -->
          <div class="row mt-3">
            <div class="col-12 col-md me-md-1 mb-3">
              <AreaChart ref="planAduccionChart5" :dataSet="v_dataSet" chartID="chartplanAduccion5"
                selDataSet="planAduccion" yAxisUnit="m3/s" estilo="width: 100%; height: 250px;" :yAxisLabel="false"
                :basicMode="true" style="border: 1px solid #ccc; padding: 5px" />
            </div>
            <div class="col-12 col-md mt-3 mt-md-0 ms-md-1">
              <AreaChart ref="volEmbalsadoChart5" :dataSet="v_dataSet" chartID="chartplanVolumen5"
                selDataSet="planVolumen" yAxisUnit="hm3" estilo="width: 100%; height: 250px;" :yAxisLabel="false"
                :basicMode="true" style="border: 1px solid #ccc; padding: 5px" />
            </div>
          </div>
          <DataTable ref="volCaudalEcologicoTable" globalID="volCaudalEcologicoTable" :dataSet="v_dataSet && v_dataSet.planCaudalEco
            ? v_dataSet.planCaudalEco
            : {}
            " :isEditable="true" @updateValues="updateCaudalEcologico" :interruptor="interruptor" />
        </div>


        <!-- TAB Volumen Evaporaciones -->
        <div class="tab-pane fade show" id="ssvolEvaporaciones" role="tabpanel"
          aria-labelledby="ssvolEvaporaciones-tab">
          <!-- Graficas reactivas -->
          <div class="row mt-3">
            <div class="col-12 col-md me-md-1 mb-3">
              <AreaChart ref="planAduccionChart6" :dataSet="v_dataSet" chartID="chartplanAduccion6"
                selDataSet="planAduccion" yAxisUnit="m3/s" estilo="width: 100%; height: 250px;" :yAxisLabel="false"
                :basicMode="true" style="border: 1px solid #ccc; padding: 5px" />
            </div>
            <div class="col-12 col-md mt-3 mt-md-0 ms-md-1">
              <AreaChart ref="volEmbalsadoChart6" :dataSet="v_dataSet" chartID="chartplanVolumen6"
                selDataSet="planVolumen" yAxisUnit="hm3" estilo="width: 100%; height: 250px;" :yAxisLabel="false"
                :basicMode="true" style="border: 1px solid #ccc; padding: 5px" />
            </div>
          </div>
          <DataTable ref="volEvaporacionesTable" globalID="volEvaporacionesTable" :dataSet="v_dataSet && v_dataSet.planEvaporaciones
            ? v_dataSet.planEvaporaciones
            : {}
            " :isEditable="viewMode ? false : true" @updateValues="updateEvaporaciones"
            :planFromDataBase="dataSetFromDatabase ? true : false" :interruptor="interruptor" />
        </div>
      </div>
    </div>
    <!-- TABS -->
  </div>
</template>


<script>
import { mapState, mapActions } from "vuex";
import DataTable from "./../DataTable";
import AreaChart from "./../AreaChart";
import Select from "@/components/commons/Select";

export default {
  data() {
    return {
      planVolumenAct: null
    };
  },
  props: {
    viewMode: {
      type: Boolean,
      default: true,
    },
    dataSetFromDatabase: {
      type: Boolean,
      default: true
    },
    interruptor: {
      type: Boolean,
      default: true
    },
  },
  components: {
    Select,
    DataTable,
    AreaChart,
  },
  watch: {
    selectedYear: function (newVal, oldVal) {
      if (newVal != null) {
        this.v_updSelectedYear(newVal);
      }
    },

    selectedCriteria: function (newVal, oldVal) {
      if (newVal != null) {
        this.v_updSelectedCriteria(newVal);
      }
    },

    attachmentFilename: function (newVal, oldVal) {
      if (newVal != null) {
        this.v_updSelectedFilename(newVal);
      }
    },
    v_dataSet: function (newVal) {
      //console.log("Antes de ordenar: ", newVal.planAduccion.filas);

      // Ordenar por fecha
      // newVal.planAduccion.filas.sort((a, b) => {
      //   const fechaA = new Date(a.fecha.split('/').reverse().join('-')); // Convierte DD/MM/YYYY a YYYY-MM-DD
      //   const fechaB = new Date(b.fecha.split('/').reverse().join('-')); // Convierte DD/MM/YYYY a YYYY-MM-DD
      //   return fechaA - fechaB; // Orden ascendente
      // });

      // newVal.planVolumen.filas.sort((a, b) => {
      //   const fechaA = new Date(a.fecha.split('/').reverse().join('-')); // Convierte DD/MM/YYYY a YYYY-MM-DD
      //   const fechaB = new Date(b.fecha.split('/').reverse().join('-')); // Convierte DD/MM/YYYY a YYYY-MM-DD
      //   return fechaA - fechaB; // Orden ascendente
      // });

      // newVal.planTrasvases.filas.sort((a, b) => {
      //   const fechaA = new Date(a.fecha.split('/').reverse().join('-')); // Convierte DD/MM/YYYY a YYYY-MM-DD
      //   const fechaB = new Date(b.fecha.split('/').reverse().join('-')); // Convierte DD/MM/YYYY a YYYY-MM-DD
      //   return fechaA - fechaB; // Orden ascendente
      // });

      // newVal.planCaudalEco.filas.sort((a, b) => {
      //   const fechaA = new Date(a.fecha.split('/').reverse().join('-')); // Convierte DD/MM/YYYY a YYYY-MM-DD
      //   const fechaB = new Date(b.fecha.split('/').reverse().join('-')); // Convierte DD/MM/YYYY a YYYY-MM-DD
      //   return fechaA - fechaB; // Orden ascendente
      // });

      // newVal.planAportaciones.filas.sort((a, b) => {
      //   const fechaA = new Date(a.fecha.split('/').reverse().join('-')); // Convierte DD/MM/YYYY a YYYY-MM-DD
      //   const fechaB = new Date(b.fecha.split('/').reverse().join('-')); // Convierte DD/MM/YYYY a YYYY-MM-DD
      //   return fechaA - fechaB; // Orden ascendente
      // });

      // newVal.planReajustes.filas.sort((a, b) => {
      //   const fechaA = new Date(a.fecha.split('/').reverse().join('-')); // Convierte DD/MM/YYYY a YYYY-MM-DD
      //   const fechaB = new Date(b.fecha.split('/').reverse().join('-')); // Convierte DD/MM/YYYY a YYYY-MM-DD
      //   return fechaA - fechaB; // Orden ascendente
      // });

      // newVal.planEvaporaciones.filas.sort((a, b) => {
      //   const fechaA = new Date(a.fecha.split('/').reverse().join('-')); // Convierte DD/MM/YYYY a YYYY-MM-DD
      //   const fechaB = new Date(b.fecha.split('/').reverse().join('-')); // Convierte DD/MM/YYYY a YYYY-MM-DD
      //   return fechaA - fechaB; // Orden ascendente
      // });




      // console.log("Después de ordenar: ", newVal);
      return newVal;
    }

  },
  computed: {
    ...mapState("planner", ["v_selectedYear", "v_dataSet"]),
    caudalesChartTitle: function (val) {
      let titulo = "CAUDALES EN " + this.v_selectedYear;
      return titulo;
    },
    volumenesChartTitle: function (val) {
      let titulo = "VOLÚMENES EN " + this.v_selectedYear;
      return titulo;
    },
    reajustesTitle: function (val) {
      let titulo = "REAJUSTES EN " + this.v_selectedYear;
      return titulo;
    },
    aportacionesTitle: function (val) {
      let titulo = "APORTACIONES EN " + this.v_selectedYear;
      return titulo;
    },
    trasvasesTitle: function (val) {
      let titulo = "TRASVASES EN " + this.v_selectedYear;
      return titulo;
    },
    caudalEcologicoTitle: function (val) {
      let titulo = "CAUDAL ECOLÓGICO EN " + this.v_selectedYear;
      return titulo;
    },
    evaporacionesTitle: function (val) {
      let titulo = "EVAPORACIONES EN " + this.v_selectedYear;
      return titulo;
    },
  },
  methods: {
    ...mapActions("planner", [
      "v_updSelectedYear",
      "v_updSelectedCriteria",
      "v_updSelectedFilename",
      "v_updDataSetAduccion",
      "v_updDataSetTransfers",
      "v_updDataSetReadjustments",
      "v_updDataSetVolumes",
      "v_updSelectedYearType",
      "v_updDataSetCaudal",
      "v_updDataSetAportaciones",
      "v_updDataSetEvaporaciones"


    ]),

    async updateAduccion(newDataSet, pos) {
      // Importante el orden
      await this.v_updDataSetAduccion(await this.recalcFormat(newDataSet, pos));
      //await this.v_updDataSetVolumes(await this.recalculateValues(pos));
    },
    async updateTrasvases(newDataSet, pos) {
      // Importante el orden
      await this.v_updDataSetTransfers(newDataSet);
      await this.v_updDataSetVolumes(await this.recalculateValues(pos));
    },

    async updateReajustes(newDataSet, pos) {
      // Importante el orden
      this.v_updDataSetReadjustments(newDataSet);
      await this.v_updDataSetVolumes(await this.recalculateValues(pos));
    },
    async updateAportaciones(newDataSet, pos) {
      // Importante el orden
      this.v_updDataSetAportaciones(newDataSet);
      await this.v_updDataSetVolumes(await this.recalculateValues(pos));
    },
    async updateCaudalEcologico(newDataSet, pos) {
      // Importante el orden
      await this.v_updDataSetCaudal(newDataSet);
      await this.v_updDataSetVolumes(await this.recalculateValues(pos));
    },
    async updateEvaporaciones(newDataSet, pos) {
      // Importante el orden
      this.v_updDataSetEvaporaciones(newDataSet);
      await this.v_updDataSetVolumes(await this.recalculateValues(pos));
    },

    /** RECALCULO DE HM3 A M3S */
    async recalcFormat(newDataSet, pos) {
      try {
        //console.log("pos",pos)
        // Validación: Verificar que pos sea un array válido con al menos 3 elementos
        if (!Array.isArray(pos) || pos.length < 3) {
          throw new Error(`Error en recalcFormat: 'pos' no es válido o tiene menos de 3 elementos: ${JSON.stringify(pos)}`);
        }

        // Convertir índices a números
        let filaIndex = parseInt(pos[1], 10);
        let aguaIndex = parseInt(pos[2], 10);
        let propiedad = pos[3] || "extraido"; // Si pos[3] no existe, usar "extraido" por defecto

        // Validación: Asegurar que filaIndex y aguaIndex sean números válidos
        if (isNaN(filaIndex) || isNaN(aguaIndex)) {
          throw new Error(`Error en recalcFormat: filaIndex (${pos[1]}) o aguaIndex (${pos[2]}) no son números válidos.`);
        }

        // Validar que filas exista y tenga suficientes elementos
        if (!newDataSet.filas || !Array.isArray(newDataSet.filas) || newDataSet.filas.length <= filaIndex) {
          throw new Error(`Error en recalcFormat: 'filas' no es un array válido o el índice ${filaIndex} está fuera de rango.`);
        }

        // Validar que masasAgua exista y tenga suficientes elementos
        if (!newDataSet.filas[filaIndex].masasAgua || !Array.isArray(newDataSet.filas[filaIndex].masasAgua) || newDataSet.filas[filaIndex].masasAgua.length <= aguaIndex) {
          throw new Error(`Error en recalcFormat: 'masasAgua' no es un array válido o el índice ${aguaIndex} está fuera de rango.`);
        }

        // Copiar objeto
        let planAduccionAct = await this.copyObject(newDataSet);

        // Buscar el índice de "Total Aducido"
        let index = planAduccionAct.filas[filaIndex].masasAgua.findIndex((x) =>
          x.label.includes("Total Aducido")
        );

        if (index === -1) {
          throw new Error(`Error en recalcFormat: No se encontró "Total Aducido" en masasAgua de filas[${filaIndex}].`);
        }

        // Cálculo del caudal
        if (planAduccionAct.filas[filaIndex].masasAgua[aguaIndex][propiedad].value != '-') {
          planAduccionAct.filas[filaIndex].masasAgua[aguaIndex].caudal.value = (
            parseFloat(planAduccionAct.filas[filaIndex].masasAgua[aguaIndex][propiedad].value) *
            11.5740 /
            parseFloat(planAduccionAct.filas[filaIndex].ndias)
          ).toFixed(3);

          //console.log(planAduccionAct.filas[filaIndex].ndias, "NDIAS");
        }
        // Sumar valores de extraído
        let sum = 0;
        for (let z = 0; z < planAduccionAct.filas[filaIndex].masasAgua.length; z++) {
          if (planAduccionAct.filas[filaIndex].masasAgua[z].label !== "Total Aducido" && planAduccionAct.filas[filaIndex].masasAgua[z][propiedad].value != '-' && planAduccionAct.filas[filaIndex].masasAgua[z].label !== "Total") {
            let valor = 0;
            if (
              planAduccionAct.filas[filaIndex] &&
              planAduccionAct.filas[filaIndex].masasAgua &&
              planAduccionAct.filas[filaIndex].masasAgua[z] &&
              planAduccionAct.filas[filaIndex].masasAgua[z][propiedad] &&
              planAduccionAct.filas[filaIndex].masasAgua[z][propiedad].value
            ) {
              valor = parseFloat(planAduccionAct.filas[filaIndex].masasAgua[z][propiedad].value);
            }

            sum += valor;
          }
        }


        // Actualizar el valor total aducido
        planAduccionAct.filas[filaIndex].masasAgua[index][propiedad].value = sum;
        //console.log("sum", sum)

        planAduccionAct.filas[filaIndex].masasAgua[index].caudal.value = (
          sum * 11.5740 /
          parseFloat(planAduccionAct.filas[filaIndex].ndias)
        ).toFixed(3);

        //console.log(planAduccionAct.filas[filaIndex].masasAgua[index].caudal.value, "CAUDAL");

        return planAduccionAct;
      } catch (e) {
        console.error("Ha ocurrido un error calculando:", e);
      }
    }

    ,

    /* SANITAZIE VALUES */
    sanitize(data) {
      //console.log("DATA", data);
      return data && data != "-" ? data : '0'
    },

    /* RECALCULO DE VOLÚMENES EN CALIENTE SUIGUIENDO LAS FORMULAS INDICADAS */
    async recalculateValues(pos) {
      try {
        this.planVolumenAct = await this.copyObject(this.v_dataSet.planVolumen);

        // Filtro de calculo por cada embalse
        /* Vol aracena proxima quincena = Volumen aracena actual + reajuste aracena actual - trasvase aracena actual  */
        /************************************************************************************************* */
        //console.log("Pos: ", pos, this.planVolumenAct);
        if (
          this.v_dataSet.planTrasvases.filas[pos[1]].masasAgua[pos[2]].label ==
          "Aracena"
        ) {

          this.recalcAracena(pos);


          /* Vol cala proxima quincena = vol cala + reajuste cala - trasvase cala */
          /************************************************************************************************* */
        } else if (
          this.v_dataSet.planTrasvases.filas[pos[1]].masasAgua[pos[2]].label ==
          "Cala"
        ) {

          this.recalcCala(pos);

          /* Vol melonares proxima quincena = vol melonares + reajuste melonares - trasvase melonares - aducción melonares */
          /************************************************************************************************* */
        } else if (
          this.v_dataSet.planTrasvases.filas[pos[1]].masasAgua[pos[2]].label ==
          "Los Melonares" || this.v_dataSet.planTrasvases.filas[pos[1]].masasAgua[pos[2]].label == "Melonares"
        ) {


          this.recalcMelonares(pos);
          /* Vol zufre proxima quincena = Volumen zufre + reajuste zufre - trasvase zufre + trasvase aracena */
          /************************************************************************************************* */
        } else if (
          this.v_dataSet.planTrasvases.filas[pos[1]].masasAgua[pos[2]].label ==
          "Zufre"
        ) {

          this.recalcZufre(pos);

          /* Vol minilla proxima quincena = Vol minilla + reajuste minilla - trasvase minilla + trasvase zufre - aducción minilla */
          /************************************************************************************************* */
        } else if (
          this.v_dataSet.planTrasvases.filas[pos[1]].masasAgua[pos[2]].label ==
          "La Minilla" || this.v_dataSet.planTrasvases.filas[pos[1]].masasAgua[pos[2]].label == "Minilla"
        ) {

          this.recalcMinilla(pos);
          /* Vol gergal proxima quincena = vol gergal + reajuste gergal - trasvase gergal  + trasvase minilla + trasvase cala - aducción gergal*/
          /*********************************************************************************************************************************** */
        } else if (
          this.v_dataSet.planTrasvases.filas[pos[1]].masasAgua[pos[2]].label ==
          "El Gergal" || this.v_dataSet.planTrasvases.filas[pos[1]].masasAgua[pos[2]].label == "Gergal"
        ) {

          this.recalcGergal(pos);
        }
        /*await console.log(
          this.v_dataSet.planVolumen.filas[3].masasAgua[pos[2]].extraido.value,
          this.planVolumenAct.filas[parseInt(pos[1]) + 1].masasAgua[pos[2]].extraido
            .value
        );*/
        return this.planVolumenAct;
      } catch (e) {
        console.log("Ha ocurrido un error calculando: " + e);
        //console.log(parseInt(pos[1]) + 1);
      }
    },
    recalcAracena(pos) {
      for (
        let z = parseInt(pos[1]);
        z < this.planVolumenAct.filas.length - 1;
        z++
      ) {
        this.planVolumenAct.filas[z + 1].masasAgua[0].extraido.value = (
          parseFloat(
            this.sanitize(this.planVolumenAct.filas[z].masasAgua[0].extraido.value)
          ) +
          parseFloat(
            this.sanitize(this.v_dataSet.planReajustes.filas[z].masasAgua[0].extraido
              .value)
          ) -
          parseFloat(
            this.sanitize(this.v_dataSet.planTrasvases.filas[z].masasAgua[0].extraido
              .value)
          ) -
          parseFloat(
            this.sanitize(this.v_dataSet.planCaudalEco.filas[z].masasAgua[0].extraido
              .value)
          ) +
          parseFloat(
            this.sanitize(this.v_dataSet.planAportaciones.filas[z].masasAgua[0].extraido
              .value)
          ) -
          parseFloat(
            this.sanitize(this.v_dataSet.planEvaporaciones.filas[z].masasAgua[0].extraido
              .value)
          )
        ).toString();
        /*console.log(this.planVolumenAct.filas[z].masasAgua[pos[2]].extraido.value,
          this.v_dataSet.planReajustes.filas[z].masasAgua[pos[2]].extraido
            .value,
          this.v_dataSet.planTrasvases.filas[z].masasAgua[pos[2]].extraido
            .value,
          this.planVolumenAct.filas[z + 1].masasAgua[pos[2]].extraido.value
        );*/
      }

      if (pos[0] == "volTrasvasesTable" && pos[2] == "0" || pos[0] == "volCaudalEcologicoTable" && pos[2] == "0") {
        this.recalcZufre(pos);
      }
    },
    recalcZufre(pos) {
      // INDICE
      // let index = this.v_dataSet.planTrasvases.filas[
      //   pos[1]
      // ].masasAgua.findIndex((x) => x.label.includes("Aracena"));
      // Valor
      for (
        let z = parseInt(pos[1]);
        z < this.planVolumenAct.filas.length - 1;
        z++
      ) {
        this.planVolumenAct.filas[z + 1].masasAgua[1].extraido.value = (
          parseFloat(
            this.sanitize(this.planVolumenAct.filas[z].masasAgua[1].extraido.value)
          ) +
          parseFloat(
            this.sanitize(this.v_dataSet.planReajustes.filas[z].masasAgua[1].extraido
              .value)
          ) -
          parseFloat(
            this.sanitize(this.v_dataSet.planTrasvases.filas[z].masasAgua[1].extraido
              .value)
          ) +
          parseFloat(
            this.sanitize(this.v_dataSet.planTrasvases.filas[z].masasAgua[0].extraido
              .value)
          ) -
          parseFloat(
            this.sanitize(this.v_dataSet.planCaudalEco.filas[z].masasAgua[1].extraido
              .value)
          ) +
          parseFloat(
            this.sanitize(this.v_dataSet.planAportaciones.filas[z].masasAgua[1].extraido
              .value)
          ) -
          parseFloat(
            this.sanitize(this.v_dataSet.planEvaporaciones.filas[z].masasAgua[1].extraido
              .value)
          ) +

          parseFloat(
            this.sanitize(this.v_dataSet.planCaudalEco.filas[z].masasAgua[0].extraido
              .value)
          )
        ).toString();
      }

      if (pos[0] == "volTrasvasesTable" && pos[2] == "1" || pos[0] == "volCaudalEcologicoTable" && pos[2] == "1") {
        this.recalcMinilla(pos);
      }
    },
    recalcMinilla(pos) {
      // INDICE
      let index = this.v_dataSet.planTrasvases.filas[
        pos[1]
      ].masasAgua.findIndex((x) => x.label.includes("Zufre"));
      let index2 = this.v_dataSet.planAduccion.filas[
        pos[1]
      ].masasAgua.findIndex((x) => x.label.includes("La Minilla") || x.label.includes("Minilla"));
      // Valor
      for (
        let z = parseInt(pos[1]);
        z < this.planVolumenAct.filas.length - 1;
        z++
      ) {
        this.planVolumenAct.filas[z + 1].masasAgua[2].extraido.value = (
          parseFloat(
            this.sanitize(this.planVolumenAct.filas[z].masasAgua[2].extraido.value)
          ) +
          parseFloat(
            this.sanitize(this.v_dataSet.planReajustes.filas[z].masasAgua[2].extraido
              .value)
          ) -
          parseFloat(
            this.sanitize(this.v_dataSet.planTrasvases.filas[z].masasAgua[2].extraido
              .value)
          ) +
          parseFloat(
            this.sanitize(this.v_dataSet.planTrasvases.filas[z].masasAgua[index].extraido
              .value)
          ) -
          parseFloat(
            this.v_dataSet.planAduccion.filas[z].masasAgua[index2].extraido
              .value &&
              this.v_dataSet.planAduccion.filas[z].masasAgua[index2]
                .extraido.value != "-"
              ? this.v_dataSet.planAduccion.filas[z].masasAgua[index2]
                .extraido.value
              : "0"
          ) -
          parseFloat(
            this.sanitize(this.v_dataSet.planCaudalEco.filas[z].masasAgua[2].extraido
              .value)
          ) +
          parseFloat(
            this.sanitize(this.v_dataSet.planAportaciones.filas[z].masasAgua[2].extraido
              .value)
          ) -
          parseFloat(
            this.sanitize(this.v_dataSet.planEvaporaciones.filas[z].masasAgua[2].extraido
              .value)
          ) +
          parseFloat(
            this.sanitize(this.v_dataSet.planCaudalEco.filas[z].masasAgua[index].extraido
              .value)
          )
        ).toString();
      }
      if (pos[0] == "volTrasvasesTable" && pos[2] == "2" || pos[0] == "volCaudalEcologicoTable" && pos[2] == "2") {
        this.recalcGergal(pos);
      }
    },
    recalcGergal(pos) {
      // INDICE
      let index = this.v_dataSet.planTrasvases.filas[
        pos[1]
      ].masasAgua.findIndex((x) => x.label.includes("La Minilla") || x.label.includes("Minilla"));
      let index2 = this.v_dataSet.planTrasvases.filas[
        pos[1]
      ].masasAgua.findIndex((x) => x.label.includes("Cala"));
      let index3 = this.v_dataSet.planAduccion.filas[
        pos[1]
      ].masasAgua.findIndex((x) => x.label.includes("El Gergal") || x.label.includes("Gergal"));
      // Valor
      for (
        let z = parseInt(pos[1]);
        z < this.planVolumenAct.filas.length - 1;
        z++
      ) {
        this.planVolumenAct.filas[z + 1].masasAgua[3].extraido.value = (
          parseFloat(
            this.sanitize(this.planVolumenAct.filas[z].masasAgua[3].extraido.value)
          ) +
          parseFloat(
            this.sanitize(this.v_dataSet.planReajustes.filas[z].masasAgua[3].extraido
              .value)
          )
          //  -
          // parseFloat(
          //   this.v_dataSet.planTrasvases.filas[z].masasAgua[3].extraido
          //     .value
          // ) 
          +
          parseFloat(
            this.sanitize(this.v_dataSet.planTrasvases.filas[z].masasAgua[index].extraido
              .value)
          ) +
          parseFloat(
            this.sanitize(this.v_dataSet.planTrasvases.filas[z].masasAgua[index2].extraido
              .value)
          ) -
          parseFloat(
            this.v_dataSet.planAduccion.filas[z].masasAgua[index3].extraido
              .value &&
              this.v_dataSet.planAduccion.filas[z].masasAgua[index3]
                .extraido.value != "-"
              ? this.v_dataSet.planAduccion.filas[z].masasAgua[index3]
                .extraido.value
              : "0"
          ) +
          parseFloat(
            this.sanitize(this.v_dataSet.planCaudalEco.filas[z].masasAgua[index2].extraido
              .value)
          ) +
          parseFloat(
            this.sanitize(this.v_dataSet.planCaudalEco.filas[z].masasAgua[index].extraido
              .value)
          ) +
          parseFloat(
            this.sanitize(this.v_dataSet.planAportaciones.filas[z].masasAgua[3].extraido
              .value)
          ) -
          parseFloat(
            this.sanitize(this.v_dataSet.planCaudalEco.filas[z].masasAgua[3].extraido
              .value)
          ) -
          parseFloat(
            this.sanitize(this.v_dataSet.planEvaporaciones.filas[z].masasAgua[3].extraido
              .value)
          )
        ).toString();
      }
    },
    recalcCala(pos) {
      for (
        let z = parseInt(pos[1]);
        z < this.planVolumenAct.filas.length - 1;
        z++
      ) {
        this.planVolumenAct.filas[z + 1].masasAgua[4].extraido.value = (
          parseFloat(
            this.sanitize(this.planVolumenAct.filas[z].masasAgua[4].extraido.value)
          ) +
          parseFloat(
            this.sanitize(this.v_dataSet.planReajustes.filas[z].masasAgua[4].extraido
              .value)
          ) -
          parseFloat(
            this.sanitize(this.v_dataSet.planTrasvases.filas[z].masasAgua[4].extraido
              .value)
          ) -
          parseFloat(
            this.sanitize(this.v_dataSet.planCaudalEco.filas[z].masasAgua[4].extraido
              .value)
          ) +
          parseFloat(
            this.sanitize(this.v_dataSet.planAportaciones.filas[z].masasAgua[4].extraido
              .value)
          ) -
          parseFloat(
            this.sanitize(this.v_dataSet.planEvaporaciones.filas[z].masasAgua[4].extraido
              .value)
          )
        ).toString();
      }

      if (pos[0] == "volTrasvasesTable" && pos[2] == "4" || pos[0] == "volCaudalEcologicoTable" && pos[2] == "4") {
        this.recalcGergal(pos);
      }
    },
    recalcMelonares(pos) {
      // INDICE
      let index = this.v_dataSet.planAduccion.filas[
        pos[1]
      ].masasAgua.findIndex((x) => x.label.includes("Los Melonares") || x.label.includes("Melonares"));
      // Valor
      for (
        let z = parseInt(pos[1]);
        z < this.planVolumenAct.filas.length - 1;
        z++
      ) {
        this.planVolumenAct.filas[z + 1].masasAgua[5].extraido.value = (
          parseFloat(
            this.sanitize(this.planVolumenAct.filas[z].masasAgua[5].extraido.value)
          ) +
          parseFloat(
            this.sanitize(this.v_dataSet.planReajustes.filas[z].masasAgua[5].extraido
              .value)
          ) -
          parseFloat(
            this.sanitize(this.v_dataSet.planTrasvases.filas[z].masasAgua[5].extraido
              .value)
          )
          // ) -
          // parseFloat(
          //   this.v_dataSet.planAduccion.filas[z].masasAgua[index].extraido
          //     .value &&
          //     this.v_dataSet.planAduccion.filas[z].masasAgua[index]
          //       .extraido.value != "-"
          //     ? this.v_dataSet.planAduccion.filas[z].masasAgua[index]
          //         .extraido.value
          //     : "0"                  
          // ) 
          // 
          +
          parseFloat(
            this.sanitize(this.v_dataSet.planCaudalEco.filas[z].masasAgua[5].extraido
              .value)
          ) +
          parseFloat(
            this.sanitize(this.v_dataSet.planAportaciones.filas[z].masasAgua[5].extraido
              .value)
          )
        ).toString();
      }
    },

    //Funcion para copiar el objeto y que se deslinke la misma referencia en memoria
    copyObject(obj) {
      return JSON.parse(JSON.stringify(obj));
    },

    /* HOOK para tener reactivamente el nombre dle fichero que se va a subir */
    updateFilename(filename) {
      this.attachmentFilename = filename;
    },
    /* Trigger para forzar el cuadro de seleccion dle input pulsando en otro sitio */
    triggerFakeInput() {
      document.getElementById("csvFileBtn").click();
    },
  },
  mounted() { 
  },
};
</script>

<style scoped>
/* Sobreescribir configuraciones por defecto */
.card {
  max-width: 100%;
}

.nav-tabs .nav-link {
  color: gray;
  border: 0;
  border-bottom: 1px solid grey;
}

.nav-tabs .nav-link:hover {
  border: 0;
  border-bottom: 1px solid grey;
}

.nav-tabs .nav-link.active {
  color: #000000;
  border: 0;
  border-radius: 1;
  border-bottom: 2px solid #4ca1ef;
  background-color: #cde9ff;
}

.nav-item:hover {
  background-color: #f0f7fc;
  transition: background-color 0.5s ease;
}

.form-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #333333;
}

.tableTitle {}
</style>